import React, { memo, useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { PlacesAutocomplete } from '@yme/atoms/autocomplete-places';
import { ModalWindowFooter } from '@yme/atoms/modal-footer';
import { XLG_MODAL, StaticModalWindow } from '@yme/atoms/modal-window';
import { setIsModalHide } from '@yme/modals/actions';
import { DealerCardCheckoutMap } from '@yme/molecules/dealer-card/checkout';
import { Map } from '@yme/molecules/map';
import { useTranslation } from '@yme/services/i18n';
import { getDealerById } from '@yme/utils/dealer';
import { InputWrapperStyled, MapContainerStyled } from '../styled';
export const MapModalDesktop = memo(({ selectedDealerId, dealers, myLocation, isRightToLeft, googleApiKey, inputLocation, preselectedDealerId, country = '', setSelectedDealerId, submitDealer, setInputLocation, handleMapInfoWindowDismiss, }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const closeModal = useCallback(() => {
        dispatch(setIsModalHide());
    }, [dispatch]);
    const closeInfoWindow = useCallback(() => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        setSelectedDealerId('');
        handleMapInfoWindowDismiss();
    }, [handleMapInfoWindowDismiss, setSelectedDealerId]);
    const handleMarkerSubmit = useCallback(() => {
        if (selectedDealerId) {
            submitDealer(selectedDealerId);
        }
        closeModal();
    }, [selectedDealerId, closeModal, submitDealer]);
    const InfoWindowElement = useMemo(() => {
        if (!selectedDealerId) {
            return null;
        }
        const dealer = getDealerById(dealers, selectedDealerId);
        if (!dealer) {
            return null;
        }
        const { name, distance, addressLines, zipCode } = dealer;
        return (React.createElement(DealerCardCheckoutMap, { name: name, distance: distance, addressLines: addressLines, zipCode: zipCode, onDismiss: closeInfoWindow, onSubmit: handleMarkerSubmit }));
    }, [selectedDealerId, dealers, closeInfoWindow, handleMarkerSubmit]);
    const FooterElement = useMemo(() => (React.createElement(ModalWindowFooter, { isCancelButton: true, isSubmitButton: true, submitButtonLabel: t('common_confirm_button'), isSubmitButtonDisabled: !(selectedDealerId || preselectedDealerId), cancelButtonLabel: t('common_cancel_button'), onSubmit: handleMarkerSubmit, onHide: closeModal })), [selectedDealerId, preselectedDealerId, closeModal, handleMarkerSubmit, t]);
    return (React.createElement(StaticModalWindow, { minHeight: "auto", staticModalSize: XLG_MODAL, title: t('common_preferredDealerFindDealerPopUp_header'), isRightToLeft: isRightToLeft, footerComponent: FooterElement },
        React.createElement(React.Fragment, null,
            React.createElement(InputWrapperStyled, null,
                React.createElement(PlacesAutocomplete, { countries: [country], apiKey: googleApiKey, value: inputLocation?.label, title: t('common_preferredDealerFindDealerPopUpYourLocation_label'), isRightToLeft: isRightToLeft, onClear: setInputLocation, onOptionSelect: setInputLocation })),
            React.createElement(MapContainerStyled, null,
                React.createElement(Map, { selectedMarkerId: selectedDealerId, preSelectedMarkerId: preselectedDealerId, apiKey: googleApiKey, markers: dealers, myLocation: myLocation, onMarkerSelect: setSelectedDealerId, InfoWindow: InfoWindowElement })))));
});
MapModalDesktop.displayName = 'MapDesktop_Component';
